import React, { createRef, RefObject, useEffect, useState } from 'react';
import { findAccountsDtlPageByRequest } from '@/services/insureManagement'
import { SLowcodeList } from 'shj-components';
import { getWorkTypeList } from '@/services';
import { moneyRender } from '@/utils';
import { getEnums } from '@/services/homeService';
export default function (props) {
    const listRef: RefObject<any> = createRef();
    let config: any;
        config = {
            rowSelection: false,
            searchFormConfig: false,
            columns: [
                {
                    title: "门店",
                    dataIndex: "companyName",
                    width: 160
                },
                {
                    title: "姓名",
                    dataIndex: "extEmpName",
                    width: 100
                },
                {
                    title: "技能标签",
                    dataIndex: "workTypeNames",
                    width: 120,
                    ellipsis: true,
                },
                {
                    title: "身份证号码",
                    dataIndex: "idCard",
                    width: 160,
                },
                {
                    title: "流水类型",
                    dataIndex: "costTypeName",
                    width: 120
                },
                {
                    title: "金额(¥)",
                    dataIndex: "amount",
                    width: 100,
                    render: 'money'
                },
                {
                    title: "创建时间",
                    dataIndex: "createdTime",
                    itemType: "dateTime",
                    width: 160
                },
                {
                    title: "费用类型",
                    dataIndex: "turnoverTypeName",
                    width: 160
                },
                {
                    title: "账户余额(¥)",
                    dataIndex: "balance",
                    width: 120,
                    render: 'money'
                },
                {
                    title: "备注",
                    dataIndex: "remarks",
                    render: "remarkFn",
                    ellipsis: true,
                    width: 200
                },
                {
                    title: "关联单号",
                    dataIndex: "relatedCode",
                    width: 180
                }
            ],
            search: [
                {
                    name: "turnoverTypes",
                    label: "费用类型",
                    itemType: "select",
                    key: "key",
                    labelKey: "description",
                    showSearch: true,
                    optionFilterProp: "children",
                    allowClear: true,
                    mode: "multiple",
                    data: "insurTurnoverTypeEnum"
                },
                {
                    name: "costTypes",
                    label: "流水类型",
                    itemType: "select",
                    key: "key",
                    labelKey: "description",
                    showSearch: true,
                    optionFilterProp: "children",
                    allowClear: true,
                    mode: "multiple",
                    data: "InsurCostTypeEnum"
                },
                {
                    name: "workTypeIds",
                    label: "技能标签",
                    itemType: "select",
                    key: "id",
                    labelKey: "name",
                    showSearch: true,
                    optionFilterProp: "children",
                    allowClear: true,
                    mode: "multiple",
                    data: "workTypeList"
                },
                {
                    name: "searchName",
                    label: "姓名/身份证号"
                }
            ],
        }
    const fetchList = (values) => {
        return new Promise(async (resolve, reject) => {
            try {
                const { current, pageSize, query } = values;
                findAccountsDtlPageByRequest(current, pageSize, query).then(data => resolve(data))
            } catch (e) {
                reject({ success: false });
            }
        });
    };
    const getWorkTypeArr = () => {
        return getWorkTypeList().then((response: any) => {
            return response;
        });
    };
    const getStatusOptions = () => {
        return new Promise(async (resolve, reject) => {
            try {
                const insurTurnoverTypeEnum = await getEnums("plus-pm", "com.shj.saas.plus.pm.domain.insur.enums.InsurTurnoverTypeEnum")
                const InsurCostTypeEnum = await getEnums("plus-pm", "com.shj.saas.plus.pm.domain.insur.enums.InsurCostTypeEnum")
                const workTypeList = await getWorkTypeArr();
                resolve({
                    insurTurnoverTypeEnum,
                    workTypeList,
                    InsurCostTypeEnum
                });
            } catch (e) { }
        });
    };
    const extension = {
        request: { fetchList, getStatusOptions },
        customRender: {
            money(text: any) {
                return <span>{moneyRender(text)}</span>
            },
        }
    };

    return (
        <SLowcodeList
            searchMode="group"
            ref={listRef}
            config={config}
            {...extension}
        />
    );
};